import store from '@/store';

export const SOCKET_ACTIONS = {
  RUN_VIDEO: 'run_video',
  RUN_CHANNEL: 'run_channel',
  RUN_SOURCE: 'run_source',
  OPEN_SOURCE_APP: 'open_source_app',
  OPEN_APP: 'open_app',
  SET_LANGUAGE: 'set_language',
  SET_TV_PACKAGE: 'set_tvpackage',
  TURN_OFF: 'turn_off',
  TURN_ON: 'turn_on',
  SOCKET_ONOPEN: 'send_message',
  OPEN_WELCOME_SCREEN: 'open_welcome_screen',
  OPEN_HOME: 'open_home',
  REBOOT: 'reboot',
  UPDATE: 'update',
};

export default class SocketHandler {
  socket = null;

  constructor({ groupId, buildingId, deviceId }) {
    this.gid = store.state.device.groupId;
    this.url = `${process.env.SOCKET_BASE}/socket/client/${this.git}/${this.bid}/tv/${deviceId}`;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/SocketHandler.js